import { createAsyncAction, createAction } from "typesafe-actions";
import { FetchedStandard, StandardElement, StandardElementPart } from "./types";

export const fetchRootStandards = createAsyncAction(
  "STANDARDS/ROOT/REQUEST",
  "STANDARDS/ROOT/SUCCESS",
  "STANDARDS/ROOT/FAILURE",
)<never, { data: FetchedStandard[] }, never>();

export const fetchStandards = createAsyncAction(
  "STANDARDS/LIST/REQUEST",
  "STANDARDS/LIST/SUCCESS",
  "STANDARDS/LIST/FAILURE",
)<
  { search: string; id?: string },
  { data: FetchedStandard[]; searchTotalCount: number },
  never
>();

export const fetchStandard = createAction("STANDARDS/STANDARD_COMPLETE_INFO")<{
  id: string;
}>();

export const fetchSingleStandard = createAction(
  "STANDARDS/STANDARD_ONLY_INFO",
)<{
  standard: FetchedStandard;
}>();

export const fetchStandardChildren = createAction("STANDARDS/CHILDREN")<{
  standards: FetchedStandard[];
  id: string;
}>();

export const fetchStandardScopes = createAction("STANDARDS/SCOPES")<{
  elements: StandardElement[];
  elementParts: StandardElementPart[];
  id: string;
}>();

export const reset = createAction("STANDARDS/RESET")<never>();
